import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateExternalToolDto } from '@inference.engine/api-client/web';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { createExternalTool } from '../api';
import { EXTERNAL_TOOLS_QUERY_KEY } from './queryKeys';

export const useCreateExternalTool = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body, workspaceId }: { body: CreateExternalToolDto; workspaceId?: string }) =>
      createExternalTool(body, workspaceId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOLS_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t('admin:externalTool.useCreateExternalTool.externalToolCreatedSuccessfully'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t('admin:externalTool.useCreateExternalTool.failedToCreateExternalTool'),
      );
      logger.error('Failed to create external tool:', error);
    },
  });
};
